import styled from '@emotion/styled'
import { Text } from 'components/Typography'

export const SChildrenWrapper = styled.div<{ maxHeight: string }>`
  ${({ maxHeight }) => `max-height: ${maxHeight};`}
  transition: max-height 0.5s linear;
  overflow: hidden;
`

export const SToggleButton = styled(Text)<{ expanded: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  color: var(--c-blue500);

  & > svg {
    transition: transform 0.5s ease;
    margin-left: 0.5rem;
    ${({ expanded }) => expanded && `transform: rotate(180deg);`}
  }

  &:before {
    content: '';
    position: absolute;
    bottom: 1.7rem;
    left: 0;
    right: 0;
    height: 5rem;

    background: linear-gradient(360deg, white, rgba(255, 255, 255, 0));
    pointer-events: none;

    ${({ expanded }) => expanded && `display: none`}
  }
`
